import { Platform } from 'react-native';
import { useRem } from '../../hooks/useRem';
import { useStyle } from '../../hooks/useStyle';
export function useToastStyle(zIndex) {
    const rem = useRem();
    return useStyle({
        nonModelBox: {
            position: Platform.OS === 'web' ? 'fixed' : 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex,
        },
        centeredView: {
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
        },
        modalView: {
            marginLeft: rem(20),
            marginRight: rem(20),
            paddingVertical: rem(16),
            paddingHorizontal: rem(12),
            backgroundColor: 'rgba(44, 44, 44, 0.72)',
            borderRadius: 8,
            alignItems: 'center',
        },
        modalText: {
            color: '#fff',
            fontSize: 16,
            fontWeight: '400',
            textAlign: 'center',
        },
    });
}
